<!--
 * @Author: ZhaoG
 * @Date: 2025-04-09 10:57:16
 * @LastEditors: ZhaoG
 * @LastEditTime: 2026-01-21 09:43:20
 * @FilePath: \eva-fe\src\app\sourcingFlow\views\expertsIn\expertsIn.vue
 * @Description: 
-->
<template>
  <div class="ccui-app-iframe-no-operate-container">
    <breadcrumbSourcing :breadcrumb-data="breadcrumbData"></breadcrumbSourcing>
    <div class="ccui-app-iframe-container-no-operate-detail">
      <div class="ccui-app-iframe-container-detail-body">
        <div class="ccui-tab-iframe">
          <div class="ccui-tab-wrapper">
            <el-button type="table-top-active" size="mini">
              签到记录
            </el-button>
          </div>
          <div class="fr">
            <el-button
              type="single-number"
              v-preventReClick
              @click="dealExpertSign"
              >签到</el-button
            >
            <el-button
              type="single-number"
              v-preventReClick
              @click="resetSign(2)"
              >重置签名</el-button
            >
            <el-button
              type="single-number"
              v-preventReClick
              @click="exportExcel"
              >导出</el-button
            >
          </div>
          <div class="clearfix"></div>
        </div>
        <!--        <el-tabs class="el-tabs__customize">-->
        <!--          <el-tab-pane label="签到记录">-->
        <el-table :data="tableData" border class="dic-sub-table-style01">
          <el-table-column
            type="index"
            width="50"
            label="序号"
          ></el-table-column>
          <el-table-column
            property="signDate"
            label="签到日期"
            show-overflow-tooltip
            width="130"
          ></el-table-column>
          <el-table-column
            property="signTime"
            label="签到时间"
            show-overflow-tooltip
            width="130"
          ></el-table-column>
          <el-table-column
            property="expertName"
            label="专家姓名"
            show-overflow-tooltip
            width="100"
          ></el-table-column>
          <el-table-column
            property="workUnitName"
            label="工作单位"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            property="mobile"
            label="联系电话"
            show-overflow-tooltip
            width="150"
          ></el-table-column>
          <el-table-column
            property="email"
            label="邮箱地址"
            show-overflow-tooltip
            width="130"
          ></el-table-column>
          <!--              <el-table-column label="操作" width="120">-->
          <!--                <template slot-scope="{ row }">-->
          <!--                  <el-button type="text" @click="dealExpertSign(row)"-->
          <!--                    >签到</el-button-->
          <!--                  >-->
          <!--                  <el-button type="text" @click="dealExpertSign(row)"-->
          <!--                    >重署签名</el-button-->
          <!--                  >-->
          <!--                </template>-->
          <!--              </el-table-column>-->
        </el-table>
        <!--          </el-tab-pane>-->
        <!--        </el-tabs>-->
      </div>
    </div>
    <el-dialog
      title="专家扫描二维码签到"
      @close="innerVisible = false"
      width="369px"
      max-height="400px"
      :visible.sync="innerVisible"
      append-to-body
    >
      <div class="qrcode">
        <h3 style="text-align: center">
          请使用
          <span style="font-size: 16px;color: red;">微信</span>
          扫一扫签名，在手机上提交签名后，请手动关闭电脑窗口，完成签订。
        </h3>
        <br />
        <!-- 放置二维码的容器,需要给一个ref -->
        <div id="qrcode" ref="qrcode"></div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  qryExpertSignListApi,
  dealExpertSignApi,
  qryBidEvaProcessStatusApi,
  checkExpertFirstSignApi
} from "@/app/sourcingFlow/api/expertEvaluation.js";
import { exportJsonToExcel } from "@/basa/utils/Export2Excel";
import breadcrumbSourcing from "@/app/sourcingFlow/components/breadcrumb-sourcing.vue";
import bidEvaProcessStatus from "@/app/sourcingFlow/mixins/getBidEvaProcessStatus.js";
import QRCode from "qrcodejs2";
import { addUrlPerFix } from "@/basa/utils";
// import wx from "weixin-js-sdk";

export default {
  name: "expertsIn",
  components: {
    breadcrumbSourcing
  },
  inject: ["reload"],
  mixins: [bidEvaProcessStatus],
  data() {
    return {
      breadcrumbData: {
        titname: "专家签到",
        status: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .evaStatusStr
      },
      tableData: [],
      status: JSON.parse(sessionStorage.getItem("bidEvaProcessStatus"))
        .billStatus,
      innerVisible: false,
      timer: null,
      type: null
    };
  },
  watch: {
    innerVisible(newValue, oldValue) {
      if (newValue) {
        // 定时器计算二维码失效
        this.timer = setTimeout(() => {
          this.$message({
            message: "二维码已失效，请重新点击重置签名刷新二维码！",
            type: "eroor",
            duration: 3000,
            showClose: true,
            ccuiCustom: true
          });
          this.innerVisible = false;
        }, 300000);
      } else {
        clearTimeout(this.timer);
        console.log(this.type, "tttttttt");
        let title = this.type == 1 ? "签名成功！" : "重置签名成功！";
        this.$message({
          message: title,
          type: "success",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
        this.init();
      }
    }
  },
  mounted() {
    this.qryExpertSignList();
  },
  beforeDestroy() {
    clearTimeout(this.timer);
  },
  methods: {
    init() {
      this.reload();
      this.qryExpertSignList();
    },
    qryExpertSignList() {
      qryBidEvaProcessStatusApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        joinExpertId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .joinExpertId,
        purStep: this.$router.history.current.query.menuKey
      }).then(res => {
        sessionStorage.setItem(
          "bidEvaProcessStatus",
          JSON.stringify(res.data.data)
        );
        this.$set(this, "status", res.data.data.billStatus);
      });
      qryExpertSignListApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId
      }).then(res => {
        this.tableData = res.data.data;
        this.pageTotal = res.data.data.length;
      });
    },
    // 签到
    dealExpertSign() {
      checkExpertFirstSignApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        joinExpertId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .joinExpertId
      }).then(res => {
        this.type = 1;
        if (res.data.data.checkResult) {
          dealExpertSignApi({
            schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
              .schemeId,
            joinExpertId: JSON.parse(sessionStorage.getItem("expertSourceData"))
              .joinExpertId
          }).then(res => {
            this.resetSign(1);
          });
        } else {
          dealExpertSignApi({
            schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
              .schemeId,
            joinExpertId: JSON.parse(sessionStorage.getItem("expertSourceData"))
              .joinExpertId
          }).then(res => {
            this.$message({
              message: "签到成功",
              type: "success",
              duration: 3000,
              showClose: true,
              ccuiCustom: true
            });
            this.init();
          });
        }
      });
    },
    // 重置签名
    resetSign(type) {
      this.innerVisible = true;
      let qrstr = `${location.protocol}//${
        location.host
      }/expertSign.html?schemeId=${
        JSON.parse(sessionStorage.getItem("expertSourceData")).schemeId
      }&joinExpertId=${
        JSON.parse(sessionStorage.getItem("expertSourceData")).joinExpertId
      }`;
      // location.href = qrstr;
      this.$nextTick(() => {
        document.getElementById("qrcode").innerHTML = "";
        let qrcode = new QRCode(document.getElementById("qrcode"), {
          width: 320,
          height: 280, // 高度
          text: qrstr // 二维码内容
        });
        qrcode.clear(); //清除二维码
        qrcode.makeCode(qrstr); //生成另一个新的二维码
        this.type = type;
      });
    },
    // 导出开始
    exportPdf() {
      qryExpertSignListApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId
      }).then(res => {
        this.exportData = [];
        if (res.data.data.recordsTotal > 5000) {
          this.$message({
            message: "暂不支持5000行以上大批量数据导出",
            type: "warning",

            offset: document.documentElement.clientHeight / 2 - 21
          });
        } else {
          res.data.data.forEach((item, index) => {
            this.exportData.push({
              id: 1 + index,
              signDate: item.signDate,
              signTime: item.signTime,
              expertName: item.expertName,
              workUnitName: item.workUnitName,
              mobile: item.mobile,
              email: item.email
            });
          });
          if (this.ExcelJS) {
            this.exportDefaultAll();
          } else {
            this.exportCompatibleAll();
          }
        }
      });
    },
    exportExcel() {
      //
      let openUrl = document.createElement("a");
      openUrl.style.display = "none";
      let params = {
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        schemeCode: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeCode,
        schemeName: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeName
      };
      // let href = `${addUrlPerFix(
      //   process.env.VUE_APP_BASE_URL
      // )}/apis/bid/bidc/qryExpertSignPdfFile?reqBO=${JSON.stringify(params)}`;
      let href = `${addUrlPerFix(
        process.env.VUE_APP_BASE_URL
      )}/apis/bid/bidc/qryExpertSignPdfFile?reqBO=${JSON.stringify(params)}`;
      openUrl.href = encodeURI(href);
      console.log(openUrl.href);
      openUrl.setAttribute("download", "专家签名.pdf");
      document.body.appendChild(openUrl);
      openUrl.click();
      // if (this.ExcelJS) {
      //   this.exportDefault();
      // } else {
      //   this.exportCompatible();
      // }
    },
    async exportDefault() {
      const wb = new this.ExcelJS.Workbook();
      const ws1 = wb.addWorksheet("专家签到列表");
      ws1.views = [{ state: "frozen", ySplit: 1 }];

      ws1.addRow(["专家签到列表"]);
      ws1.addRow([this.content]);
      ws1.addRow([
        "序号",
        "签到日期",
        "签到时间",
        "专家姓名",
        "工作单位",
        "联系电话",
        "邮箱地址"
      ]);
      ws1.mergeCells("A1:P1");
      ws1.mergeCells("A2:P2");
      ws1.columns = [
        { key: "id", width: 5 },
        { key: "signDate", width: 25 },
        { key: "signTime", width: 25 },
        { key: "expertName", width: 25 },
        { key: "workUnitName", width: 50 },
        { key: "mobile", width: 25 },
        { key: "email", width: 25 }
      ];
      this.tableData.forEach((item, index) => {
        ws1.addRow([
          item.id,
          item.signDate,
          item.signTime,
          item.expertName,
          item.workUnitName,
          item.mobile,
          item.email
        ]);
      });
      const buf = await wb.xlsx.writeBuffer();
      this.saveAs(new Blob([buf]), "专家签到列表.xlsx");
    },
    exportCompatible() {
      const header = [
        "序号",
        "签到日期",
        "签到时间",
        "专家姓名",
        "工作单位",
        "联系电话",
        "邮箱地址"
      ];
      const filterVal = [
        "id",
        "signDate",
        "signTime",
        "expertName",
        "workUnitName",
        "mobile",
        "email"
      ];
      const excelArr = this.tableData;
      let count = 0;
      const list = [];
      excelArr.forEach((val, index) => {
        val.index = ++count;
        list.push(val);
      });
      const data = this.formatJson(filterVal, list);
      exportJsonToExcel({
        header,
        data,
        filename: "专家签到列表"
      });
    },
    async exportDefaultAll() {
      const wb = new this.ExcelJS.Workbook();
      const ws1 = wb.addWorksheet("专家签到列表");
      ws1.views = [{ state: "frozen", ySplit: 1 }];

      ws1.addRow(["专家签到列表"]);
      ws1.addRow([this.content]);
      ws1.addRow([
        "序号",
        "签到日期",
        "签到时间",
        "专家姓名",
        "工作单位",
        "联系电话",
        "邮箱地址"
      ]);
      ws1.mergeCells("A1:P1");
      ws1.mergeCells("A2:P2");
      ws1.columns = [
        { key: "id", width: 5 },
        { key: "signDate", width: 25 },
        { key: "signTime", width: 25 },
        { key: "expertName", width: 25 },
        { key: "workUnitName", width: 50 },
        { key: "mobile", width: 25 },
        { key: "email", width: 25 }
      ];
      this.exportData.forEach((item, index) => {
        ws1.addRow([
          item.id,
          item.signDate,
          item.signTime,
          item.expertName,
          item.workUnitName,
          item.mobile,
          item.email
        ]);
      });
      const buf = await wb.xlsx.writeBuffer();
      this.saveAs(new Blob([buf]), "专家签到列表.xlsx");
    },
    exportCompatibleAll() {
      const header = [
        "序号",
        "签到日期",
        "签到时间",
        "专家姓名",
        "工作单位",
        "联系电话",
        "邮箱地址"
      ];
      const filterVal = [
        "id",
        "signDate",
        "signTime",
        "expertName",
        "workUnitName",
        "mobile",
        "email"
      ];
      const excelArr = this.exportData;
      let count = 0;
      const list = [];
      excelArr.forEach((val, index) => {
        val.index = ++count;
        list.push(val);
      });
      const data = this.formatJson(filterVal, list);
      exportJsonToExcel({
        header,
        data,
        filename: "专家签到列表"
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.fr {
  float: right;
}
/deep/ .el-table td {
  height: 36px !important;
  line-height: 36px !important;
}
.qrcode {
  margin: auto;
  .h3 {
    text-align: center;
  }
}
</style>
<style>
.ccui-top-bar-wrapper {
  display: none;
}
</style>
